var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLogged)?_c('button-component',{staticClass:"btn",attrs:{"variant":"icon","disabled":_vm.disabled,"title":_vm.$t(_vm.title, {
      name: _vm.favorite.name,
      favorite: _vm.$projectSettings.favorites.translates.favorite,
    })},on:{"btn-click":_vm.toggleFavorite}},[_c('star-icon',{class:{
        empty: !_vm.isFavorite,
      }})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }